import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const applinksExtraAuthHealthcheckRoute: InvariantJiraRoute = {
	name: 'global-settings-products-applinks-extra-auth',
	path: '/jira/settings/applinks/extra-auth/healthcheck',
	exact: true,
};
